import { RESET_ALL_ACCOUNT_STATE_DEPEN } from "../actions/commonActions";
import { FETCH_GEO_WISE_REVENUE_ANALYSIS_FAILURE, FETCH_GEO_WISE_REVENUE_ANALYSIS_REQUEST, FETCH_GEO_WISE_REVENUE_ANALYSIS_SUCCESS } from "../actions/fetchGeoWiseRevenueAnalysisAction";

  const initialState = {
    geo_wise_revenue_analysis: [],
    geo_wise_revenue_analysis_loading: true,
    geo_wise_revenue_analysis_error: null,
  };
  
  const fetchGeoWiseRevenueAnalysisReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_GEO_WISE_REVENUE_ANALYSIS_REQUEST:
        return { ...state, geo_wise_revenue_analysis_loading: true , payload: action.payload};
      case FETCH_GEO_WISE_REVENUE_ANALYSIS_SUCCESS:
        return { ...state, geo_wise_revenue_analysis_loading: false, geo_wise_revenue_analysis: action.payload };
      case FETCH_GEO_WISE_REVENUE_ANALYSIS_FAILURE:
        return { ...state, geo_wise_revenue_analysis_loading: false, geo_wise_revenue_analysis_error: action.payload };
      case RESET_ALL_ACCOUNT_STATE_DEPEN:  
        return { ...state, geo_wise_revenue_analysis_loading: false, geo_wise_revenue_analysis: [] };
      default:
        return state;
    }
  };
  
  export default fetchGeoWiseRevenueAnalysisReducer;
  